import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PasswordService } from 'src/app/services/password.service';
import { checkError, CONSTANTES, getToken } from 'src/app/shared/global';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public cip: string;
  public answer1: string;
  public answer2: string;
  public answer3: string;
  public currentPassword: string;
  public phone: string = "91 780 24 76";
  public mail: string = "atencion_usuarios_avet@et.mde.es";

  // validación campos formulario
  public formForgotPassword = new FormGroup({
    cip: new FormControl("", [Validators.required]),
    answer1: new FormControl("", [Validators.required]),
    answer2: new FormControl("", [Validators.required]),
    answer3: new FormControl("", [Validators.required]),
  });

  constructor(private toastr: ToastrService, private passwordService: PasswordService, private authService: AuthenticationService, private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit() {
  }

  forgotPassword() {

    //se cogen asi los valores?
    let datos = {
      userName: this.formForgotPassword.value["cip"],
      answer1: this.formForgotPassword.value["answer1"],
      answer2: this.formForgotPassword.value["answer2"],
      answer3: this.formForgotPassword.value["answer3"],
      currentPassword: ""

    }

    this.passwordService.forgotPassword(datos).subscribe(
      data => {
        if (data.errorCode != null) {
          this.toastr.warning(data.errorCode.message, "ERROR");
          this.router.navigate(['login']);
        } else {
          this.checkLogin();
        }
      },
      error => {
        this.toastr.warning('NO HA SIDO POSIBLE MODIFICAR SU CONTRASEÑA', '', {timeOut: 10000});
        this.router.navigate(['login']);
      });

  }

  checkLogin() {

    this.spinner.show();
    let datos = {
      userName: btoa(this.formForgotPassword.value["cip"]),
      pwd1: btoa(this.formForgotPassword.value["cip"]),
      pwd2: btoa(this.formForgotPassword.value["cip"])
    }

    this.authService.authenticate(datos).subscribe(
      data => {

        if (getToken(data)) {
          if (data.versionApp === CONSTANTES.version) {
            localStorage.setItem("nid", data.nid);
            localStorage.setItem("credit", data.credit);
            localStorage.setItem("ucoCode", data.ucoCode);
            localStorage.setItem("uco", data.ucoShortDescription);
            localStorage.setItem("armyType", data.armyType);
            localStorage.setItem("role", data.role);
            localStorage.setItem("active", data.active.toString());
            localStorage.setItem("forcedChangePassword", data.forcedChangePassword.toString());
            
            if (data.forcedChangePassword === true) {
              this.router.navigate(['change-password']);
            } else {
              this.router.navigate(['home']);
            }           

          } else {
            this.toastr.warning('EXISTE UNA NUEVA VERSIÓN DE LA APP, PARA PODER CONTINUAR DESCARGALA EN AVET WEB');
            this.spinner.hide();
          }

          //this.spinner.hide();
        } else {

          this.toastr.warning(data.errorCode.message, "ERROR");
          if (!checkError(data.errorCode.code)) {
            let infoUser = {
              userName: localStorage.getItem("nid")
            }
            this.authService.logOut(infoUser).subscribe(
              data => {
                localStorage.clear();
                this.router.navigate(['login']);
              }
            );
          }

          this.spinner.hide();

        }
      },
      error => {
        this.toastr.error('LOS DATOS DE INICIO DE SESIÓN NO SON CORRECTOS');

        this.spinner.hide();

      });
  }
}
